import instance from "../root.api";

export const getProfileData = () =>
    instance
        .get(`/users/profile`)
        .then(response => ({ response }))
        .catch(response => ({ ...response }));
